import React, { useContext } from 'react';
import { Link, TextStyle } from '@superops/ui-design-system';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import { ALL_MODULES, useIntl, getTranslatedText } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';

const SourceCell = (props) => {
  const context = useContext(TicketContext);
  const intl = useIntl();

  const getSource = (data) => {
    let sourceData = null;
    if (data?.workItem?.module === ALL_MODULES.project) {
      sourceData = {
        ...data?.workItem,
        icon: 'ProjectFilled'
      };
    } else if (data?.workItem?.module === ALL_MODULES.ticket) {
      sourceData = {
        ...data?.workItem,
        icon: 'TicketFilled'
      };
    } else if (data?.ticket) {
      sourceData = {
        subject: data?.ticket?.subject,
        icon: 'TicketFilled'
      };
    } else if (data?.project) {
      sourceData = {
        subject: data?.project?.title,
        icon: 'ProjectFilled'
      };
    }
    return sourceData;
  };

  const workItem = getSource(props.row?.original);

  // const navigateToSource = () => {
  //   if (workItem?.module === ALL_MODULES.project) {
  //     context.openTab({
  //       module: ALL_MODULES.projectDetail,
  //       data: {
  //         projectId: workItem?.projectId,
  //         title: workItem?.subject
  //       }
  //     });
  //   } else if (workItem?.subject === ALL_MODULES.ticket) {
  //     context.openTab({
  //       module: ALL_MODULES.ticket,
  //       data: {
  //         subject: workItem?.subject,
  //         displayId: workItem?.displayId,
  //         ticketId: workItem?.workId
  //       }
  //     });
  //   }
  // };

  return (
    <>
      {workItem?.subject ? (
        // <Link onClick={navigateToSource} removeUnderline>
        //   {workItem.subject}
        // </Link>
        <div className="fx ellipsis">
          <div className="mr10">
            <SVGIcon name={workItem?.icon} />
          </div>
          <p className="ellipsis">
            <TextStyle>{workItem.subject}</TextStyle>
          </p>
        </div>
      ) : (
        <TextStyle variation="subdued">
          {getTranslatedText(intl, 'app.noData.message')}
        </TextStyle>
      )}
    </>
  );
};

export default SourceCell;
